import { deleteNoNeedProperties } from "./deleteNoNeedProperties";
import { LAYER_GEOMETRY_TYPES } from "./smartCityStyle";

/* *******************
 * データの重複を削除＆propertiesのないデータを除外
 * *******************/
export const uniqueFeaturesByKey = (features: { [key: string]: maplibregl.MapGeoJSONFeature[] }) => {
    const uniqueFeatures: { [key: string]: maplibregl.MapGeoJSONFeature[] } = {};
  
    Object.keys(features).forEach(key => {
      let normalizedKey = key;
  
      Object.values(LAYER_GEOMETRY_TYPES).forEach(type => { 
        normalizedKey = normalizedKey.replace(`-${type}`, '');
      });

      const newFeatures = features[key].map(feature => deleteNoNeedProperties(feature) as maplibregl.MapGeoJSONFeature);
      
      if (!newFeatures.every(feature => Object.keys(feature.properties).length === 0)) {
        uniqueFeatures[normalizedKey] = newFeatures;
      }
    });
    return uniqueFeatures;
};

/**
 * selectedFeaturesから、propertiesが_idだけでないfeatureを持つkeyのみを返す
 */
export const getValidFeatureKeys = (selectedFeatures: {
    [key: string]: maplibregl.MapGeoJSONFeature[];
} | undefined) => {
  if (!selectedFeatures) { return []; }
  
  return Object.keys(selectedFeatures).filter((key) =>
    // polygon-outlineは除外
    !key.includes('-outline') &&
    selectedFeatures[key].some(
      feature =>
        feature.properties &&
        (
          Object.keys(feature.properties).length > 1 ||
          (Object.keys(feature.properties).length === 1 && !Object.prototype.hasOwnProperty.call(feature.properties, '_id'))
        )
    )
  );
};

/**
 * propertiesオブジェクトから_id以外の項目だけを返す
 */
export const omitIdProperty = (properties: { [key: string]: unknown } | undefined) => {
  if (!properties) { return {}; }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { _id, ...rest } = properties;
  return rest;
};
